/** A native proxy's scroll range must equal the full viewport's range. */
export function getHorizontalScrollRegion(viewportWidth: number, scrollWidth: number, startInset: number, endInset: number) {
  // Native scrollWidth/clientWidth are integral; keep the proxy's range exact
  // when grid sizes or browser zoom place pinned boundaries between pixels.
  const start = Math.min(viewportWidth, Math.max(0, Math.ceil(startInset)));
  const end = Math.min(viewportWidth - start, Math.max(0, Math.ceil(endInset)));
  const trackWidth = viewportWidth - start - end;
  const maxScrollLeft = Math.max(0, scrollWidth - viewportWidth);
  return { start, end, trackWidth, contentWidth: trackWidth + maxScrollLeft, maxScrollLeft };
}
